import React, { FormEvent, useState, ChangeEvent, useContext, useEffect, MouseEvent } from 'react';
import { CouponContext } from '../../contexts/CouponContext';
import Logo from '../../components/Logo';
import {
  FormWrapper,
  CouponInput,
  Header,
  InputLabel,
  InputWrapper,
  CouponTextarea,
  TextareaWrapper,
} from './styled';
import voucher_codes from 'voucher-code-generator';
import { FormButton } from '../../components/FormButton';
import { Container, LogoWrapper, Step } from '../../components/FormElements';
import { useNavigate } from 'react-router-dom';
import { getExpiredTime, getToken, removeToken } from '../../utils/auth';

const CouponForm = (): React.ReactElement => {
  const [prefix, setPrefix] = useState('');
  const [length, setLength] = useState('');
  const [count, setCount] = useState('');
  const [generatedCode, setGeneratedCode] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const { setCouponCode } = useContext(CouponContext);
  const navigate = useNavigate();

  const generateCode = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setLoading(!loading);
    const result = voucher_codes.generate({
      prefix: prefix.toUpperCase(),
      length: Number(length),
      count: Number(count),
      charset: '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ',
    });
    if (result && result.length === Number(count)) {
      setLoading(false);
      setCouponCode(result);
      setGeneratedCode(result);
    }
  };

  useEffect(() => {
    function fetchToken() {
      const token = getToken();
      const tokenExpired = Date.now() - Number(getExpiredTime()) > 0;
      if (!token || tokenExpired) {
        removeToken();
        navigate('/');
      }
    }
    fetchToken();
  }, []);
  return (
    <>
      <Container>
        <FormWrapper onSubmit={(event: FormEvent<HTMLFormElement>) => generateCode(event)}>
          <LogoWrapper>
            <Logo />
            <Step>1/3</Step>
          </LogoWrapper>
          <Header>Generate Coupon Code</Header>
          <InputWrapper>
            <InputLabel>Coupon Prefix</InputLabel>
            <CouponInput
              required
              value={prefix}
              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                return setPrefix(e.target.value);
              }}
            />
          </InputWrapper>
          <InputWrapper>
            <InputLabel>Coupon Length</InputLabel>
            <CouponInput
              placeholder="0 < length < 11"
              required
              value={length}
              max="10"
              min="1"
              type="number"
              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                return setLength(e.target.value);
              }}
            />
          </InputWrapper>
          <InputWrapper>
            <InputLabel>Coupon Quantity</InputLabel>
            <CouponInput
              placeholder="0 < amount < 1000"
              required
              value={count}
              max="1000"
              min="1"
              type="number"
              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                return setCount(e.target.value);
              }}
            />
          </InputWrapper>
          <TextareaWrapper>
            <CouponTextarea
              name="Generated Code"
              rows={5}
              disabled
              value={generatedCode.join('\n')}
            />
          </TextareaWrapper>

          <FormButton variant="primary" size="sm" type="submit" loading={loading}>
            Generate
          </FormButton>
          <FormButton
            variant="primary"
            size="sm"
            onClick={(e: MouseEvent<HTMLButtonElement>) => {
              e.preventDefault();
              navigate('/detail');
            }}
            disabled={generatedCode.length > 0 ? false : true}
          >
            Next
          </FormButton>
        </FormWrapper>
      </Container>
    </>
  );
};

export default CouponForm;
